export default __webpack_public_path__ + "static/media/lifetime.bb95ff18.svg";